import { render, staticRenderFns } from "./QuickProductItem.vue?vue&type=template&id=715a24dc&"
import script from "./QuickProductItem.vue?vue&type=script&lang=js&"
export * from "./QuickProductItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports